import { MenuItem } from '@mui/material'
import { ChevronRight16Regular } from '@/components/Icon'
import { FloatingMenuItemLabel } from '@/components/FloatingMenuPopup/FloatingMenuItemLabel'
import { getMenuItemSx } from '@/components/FloatingMenuPopup/getMenuItemSx'
import floatingMenuStyles from '@/components/FloatingMenuPopup/index.module.scss'
import styles from './index.module.scss'

export default function AiAskBarHomeRightAgentSelectRow({
  label,
  meta,
  isSelected,
  isActive,
  showChevron,
  onClick,
  onMouseEnter,
  onKeyDown,
}) {
  const highlighted = Boolean(isSelected || isActive)
  return (
    <MenuItem
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onKeyDown={onKeyDown}
      className={floatingMenuStyles.item}
      sx={(theme) => ({
        ...getMenuItemSx(theme, {
          showIconColumn: false,
          isDisabled: false,
          isDanger: false,
          isSelected: highlighted,
        }),
        ...(showChevron || meta ? { justifyContent: 'space-between', paddingRight: '4px' } : {}),
      })}
    >
      <FloatingMenuItemLabel label={label} isSelected={isSelected} />
      {meta ? <span className={styles.agentControlRowMeta}>{meta}</span> : null}
      {showChevron ? (
        <ChevronRight16Regular
          aria-hidden
          className={`${styles.agentControlRowChevron}${isActive ? ` ${styles.agentControlRowChevronActive}` : ''}`}
        />
      ) : null}
    </MenuItem>
  )
}
